import Vue from 'vue'
import VueRouter from 'vue-router'

import axios from '@/plugin/axios'
import home from '@/App'
import login from '@/components/login'
import form from '@/components/design/form'
import form_add from '@/components/design/form_add'
import form_design from '@/components/design/form_design'

import sy_header from '@/components/design/components/control/sy-header'
import sy_cover from '@/components/design/components/control/sy-cover'
import sy_description_text from '@/components/design/components/control/sy-description-text'
import sy_address from '@/components/design/components/control/sy-address'
import sy_check from '@/components/design/components/control/sy-check'
import sy_date from '@/components/design/components/control/sy-date'
import sy_fileupload from '@/components/design/components/control/sy-fileupload'
import sy_input from '@/components/design/components/control/sy-input'
import sy_mobile from '@/components/design/components/control/sy-mobile'
import sy_number from '@/components/design/components/control/sy-number'
import sy_picker from '@/components/design/components/control/sy-picker'
import sy_range from '@/components/design/components/control/sy-range'
import sy_rater from '@/components/design/components/control/sy-rater'
import sy_select_text from '@/components/design/components/control/sy-select-text'
import sy_sign from '@/components/design/components/control/sy-sign'
import sy_switch from '@/components/design/components/control/sy-switch'
import sy_text from '@/components/design/components/control/sy-text'

import sy_address_attr from '@/components/design/components/control_attribute/sy-address-attr'

import monthLive from '@/components/month_live'
import success from '@/components/success'
import maternalFile from '@/components/maternal_file'
import maternalService from '@/components/maternal_service'
// 旧的 VUX 版本 - 已迁移到 Vant
import maternalSpecial from '@/components/maternal_special'
import maternalSpecialRoom from '@/components/maternal_special_room'
import maternalSpecialMeal from '@/components/maternal_special_meal'
// 新的 Vant 版本
import maternalSpecialVant from '@/componentsVant/ssReport/maternal_special'
import maternalSpecialRoomVant from '@/componentsVant/ssReport/maternal_special_room'
import maternalSpecialMealVant from '@/componentsVant/ssReport/maternal_special_meal'

import batchService from '@/components/batch_service'
import batchRecord from '@/components/batch_record'
import batchRecordDetail from '@/components/batch_record_detail'
import batchTable from '@/components/batch_table'
import batchSuccess from '@/components/batch_success'

import maternalInfoDetail from '@/components/maternal_info_detail'
import checkRoomService from '@/components/check_room_service'
import checkRoomRecord from '@/components/check_room_record'
import addFromRecord from '@/components/add_from_record'
import detailOtherForm from '@/components/detail_other_form'
import baseInfoHeader from '@/components/base_info_header'
import babyLive from '@/components/baby_live'
import babyMedicationList from '@/components/baby_medication_list'
import babySignList from '@/components/baby_sign_list'
import babyBreastMilkList from '@/components/baby_breast_milk_list'
import babyFeedList from '@/components/baby_feed_list'
import otherFormList from '@/components/other_form_list'
import otherFormDetail from '@/components/other_form_detail'
import leaveCustomList from '@/components/leave_custom_list'
import maternalFormList from '@/components/maternal_form_list'
import maternalFormA from '@/components/maternal_form_a'
import maternalFormADetail from '@/components/maternal_form_a_detail'
import maternalFormAEdit from '@/components/maternal_form_a_edit'
import maternalFormB from '@/components/maternal_form_b'
import maternalFormC from '@/components/maternal_form_c'
import maternalFormD from '@/components/maternal_form_d'
import bbForm from '@/components/bb_form'
import bbFormA from '@/components/bb_form_a'
import bbFormB from '@/components/bb_form_b'
import bbFormC from '@/components/bb_form_c'
import bbFormD from '@/components/bb_form_d'
import bbFormDDetail from '@/components/bb_form_d_detail'
import bbFormDEdit from '@/components/bb_form_d_edit'
import bbFormE from '@/components/bb_form_e'
import bbFormEDetail from '@/components/bb_form_e_detail'
import bbFormEEdit from '@/components/bb_form_e_edit'
import bbFormF from '@/components/bb_form_f'
import christmasFormOne from '@/components/christmas_form_one'
import christmasFormTwo from '@/components/christmas_form_two'
import christmasFormThree from '@/components/christmas_form_three'
import christmasFormFour from '@/components/christmas_form_four'
import christmasFormFive from '@/components/christmas_form_five'
import christmasFormSix from '@/components/christmas_form_six'
import christmasFormSixDetail from '@/components/christmas_form_six_detail'
import christmasFormSixEdit from '@/components/christmas_form_six_edit'
import christmasFormSeven from '@/components/christmas_form_seven'
import christmasFormSevenDetail from '@/components/christmas_form_seven_detail'
import christmasFormSevenEdit from '@/components/christmas_form_seven_edit'
import christmasFormEight from '@/components/christmas_form_eight'
import christmasFormEightDetail from '@/components/christmas_form_eight_detail'
import christmasFormEightEdit from '@/components/christmas_form_eight_edit'
import medicineCommissioned from '@/components/medicine_commissioned'
import basicNursing from '@/components/basic_nursing'
import designForm from '@/components/design/form'
import newCheckRoomRecord from '@/components/new_check_room_record'
import { Base64 } from 'js-base64';
Vue.use(VueRouter)
const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: login//login
        }, {
            path: '/month_live',
            component: monthLive
        }, {
            path: '/designForm',
            component: designForm
        }, {
            path: '/sy_header',
            component: sy_header
        },
        {
            path: '/form_add',
            component: form_add
        },
        {
            path: '/form1',
            component: form
        },
        {
            path: '/form',
            component: form_design
        },
        {
            path: '/sy_cover',
            component: sy_cover
        },
        {
            path: '/pathsy_description_text',
            component: sy_description_text
        },
        {
            path: '/sy_address',
            component: sy_address
        },
        {
            path: '/sy_check',
            component: sy_check
        },
        {
            path: '/sy_date',
            component: sy_date
        },
        {
            path: '/sy_fileupload',
            component: sy_fileupload
        },
        {
            path: '/sy_input',
            component: sy_input
        },
        {
            path: '/sy_rater',
            component: sy_rater
        },
        {
            path: '/sy_mobile',
            component: sy_mobile
        },
        {
            path: '/sy_number',
            component: sy_number
        },
        {
            path: '/sy_picker',
            component: sy_picker
        },
        {
            path: '/sy_range',
            component: sy_range
        },
        {
            path: '/sy_select_text',
            component: sy_select_text
        },
        {
            path: '/sy_sign',
            component: sy_sign
        },
        {
            path: '/sy_switch',
            component: sy_switch
        },
        {
            path: '/sy_text',
            component: sy_text
        },
        {
            path: '/sy_address_attr',
            component: sy_address_attr
        },
        {
            path: '/success',
            component: success
        }, {
            path: '/maternal_file',
            component: maternalFile
        }, {
            path: '/maternal_service',
            component: maternalService
        }, {
            // 旧的 VUX 版本路由 - 已迁移到 Vant
            // {
            //     path: '/maternal_special',
            //     component: maternalSpecial
            // }
            // 新的 Vant 版本路由
            path: '/maternal_special',
            component: maternalSpecial
        }, 
        {
            path: '/maternal_special_vant',
            component: maternalSpecialVant
        },
         {
            path: '/maternal_special_room',
            component: maternalSpecialRoom
        },
         {
            path: '/maternal_special_meal',
            component: maternalSpecialMeal
        },
         {
            path: '/maternal_special_room_vant',
            component: maternalSpecialRoomVant
        },
         {
            path: '/maternal_special_meal_vant',
            component: maternalSpecialMealVant
        },
        {
            path: '/batch_service',
            component: batchService
        }, {
            path: '/batch_record',
            component: batchRecord
        }, {
            path: '/batch_record_detail',
            component: batchRecordDetail
        }
        , {
            path: '/batch_success',
            component: batchSuccess
        }
        , {
            path: '/batch_table',
            component: batchTable
        },
        {
            path: '/maternal_info_detail',
            component: maternalInfoDetail
        }, {
            path: '/check_room_service',
            component: checkRoomService
        }, {
            path: '/check_room_record',
            component: checkRoomRecord
        }, {
            path: '/add_from_record',
            component: addFromRecord
        }, {
            path: '/detail_other_form',
            component: detailOtherForm
        }, {
            path: '/base_info_header',
            component: baseInfoHeader
        }, {
            path: '/baby_live',
            component: babyLive
        }, {
            path: '/baby_medication_list',
            component: babyMedicationList
        }, {
            path: '/baby_sign_list',
            component: babySignList
        }, {
            path: '/baby_breast_milk_list',
            component: babyBreastMilkList
        }, {
            path: '/baby_feed_list',
            component: babyFeedList
        }, {
            path: '/other_form_list',
            component: otherFormList
        }, {
            path: '/other_form_detail',
            component: otherFormDetail
        }, {
            path: '/leave_custom_list',
            component: leaveCustomList
        }, {
            path: '/maternal_form_list',
            component: maternalFormList
        },
        {
            path: '/maternal_form_a',
            component: maternalFormA
        },
        {
            path: '/maternal_form_a_detail',
            component: maternalFormADetail
        },
        {
            path: '/maternal_form_a_edit',
            component: maternalFormAEdit
        },
        {
            path: '/maternal_form_b',
            component: maternalFormB
        },
        {
            path: '/maternal_form_c',
            component: maternalFormC
        },
        {
            path: '/maternal_form_d',
            component: maternalFormD
        },
        {
            path: '/bb_form',
            component: bbForm
        },
        {
            path: '/bb_form_a',
            component: bbFormA
        },
        {
            path: '/bb_form_b',
            component: bbFormB
        },
        {
            path: '/bb_form_c',
            component: bbFormC
        },
        {
            path: '/bb_form_d',
            component: bbFormD
        },
        {
            path: '/bb_form_d_detail',
            component: bbFormDDetail
        },
        {
            path: '/bb_form_d_edit',
            component: bbFormDEdit
        },
        {
            path: '/bb_form_e',
            component: bbFormE
        },
        {
            path: '/bb_form_e_detail',
            component: bbFormEDetail
        },
        {
            path: '/bb_form_e_edit',
            component: bbFormEEdit
        },
        {
            path: '/bb_form_f',
            component: bbFormF
        },
        {
            path: '/bb_form_f',
            component: bbFormF
        },
        {
            path: '/bb_form_f',
            component: bbFormF
        },
        {
            path: '/bb_form_f',
            component: bbFormF
        },
        {
            path: '/christmas_form_one',
            component: christmasFormOne
        },
        {
            path: '/christmas_form_two',
            component: christmasFormTwo
        },
        {
            path: '/christmas_form_three',
            component: christmasFormThree
        },
        {
            path: '/christmas_form_four',
            component: christmasFormFour
        },
        {
            path: '/christmas_form_five',
            component: christmasFormFive
        },
        {
            path: '/christmas_form_six',
            component: christmasFormSix
        },
        {
            path: '/christmas_form_six_detail',
            component: christmasFormSixDetail
        },
        {
            path: '/christmas_form_six_edit',
            component: christmasFormSixEdit
        },
        {
            path: '/christmas_form_seven',
            component: christmasFormSeven
        },
        {
            path: '/christmas_form_seven_detail',
            component: christmasFormSevenDetail
        },
        {
            path: '/christmas_form_seven_edit',
            component: christmasFormSevenEdit
        },
        {
            path: '/christmas_form_eight',
            component: christmasFormEight
        },
        {
            path: '/christmas_form_eight_detail',
            component: christmasFormEightDetail
        },
        {
            path: '/christmas_form_eight_edit',
            component: christmasFormEightEdit
        },
        {
            path: '/medicine_commissioned',
            component: medicineCommissioned
        },
        {
            path: '/basic_nursing',
            component: basicNursing
        },
        {
            path: '/new_check_room_record',
            component: newCheckRoomRecord
        },
    ]
})
import Cookies from 'js-cookie'
router.beforeEach((to, from, next) => {
    let param = {
        token: Cookies.get('token'),
    }
    var parseData = JSON.stringify(param)
    var formData = new FormData();
    formData.append("data", encodeURI(Base64.encode(parseData)));
    axios.post(window.host.checkLoginUrl, formData)
        .then(function (response) {
            var data = Base64.decode(response.data)
            var jsonData = JSON.parse(data)
            console.log(jsonData)
            if (jsonData.errcode !== 1) {
                Cookies.set('token', '')
                Cookies.set('id', '')
                if (to.fullPath !== '/') {
                    next({ path: '/', replace: true })
                }
                next()
            } else {
                next()
            }
        })
        .catch(function (error) {
            next()
        })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js